// @flow

//
// React
//
import React, { useState, type Node } from 'react';

//
// Material UI
//
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Image from 'mui-image';

const renderer = (cfg: any): any => (props: any): any => {
    const [open, setOpen] = useState(false);
    
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const row = (props.row) ? props.row : {};

    const stock = (row && row.stock) ? row.stock : {}
    const sku = (stock.sku) ? stock.sku : (stock.barcode) ? stock.barcode : '';
    const name = (stock.name && stock.name.bg) ? stock.name.bg : '';

    // PATCH: 
    const imageUrl = `https://trix.tendenz.bg/rp/${sku.substring(0, sku.length - 2)}_1.jpg`;
    // const imageUrl = 'https://img.tendenz.bg/2d0f648eb7b42b1bc5e429268d58b9dd0137269.jpg';

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    gap: 2,
                    padding: '8px',
                }}
            >
                <Box
                    sx={{
                        flex: '0 0 auto',
                        width: 100,
                    }}
                >
                    <Image
                        src={imageUrl}
                        style={{ cursor: 'pointer', borderRadius: 8 }}
                        onClick={handleOpen}
                        showLoading
                    />
                </Box>

                <Box 
                    sx={{
                        flex: '1 1 100px',
                        minWidth: '100px',
                        wordBreak: 'break-word',
                    }}
                >
                    <Typography variant='subtitle2' display='block'>
                        {sku}
                    </Typography>
                    <Typography variant='caption' display='block'>
                        {name}
                    </Typography>
                </Box>
            </Box>

            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                <Image
                    src={imageUrl}
                    fit='contain'
                    style={{ maxWidth: '100%', maxHeight: '80vh' }}
                />
                </Box>
            </Modal>
        </>
    );

    // return (
    //     <>
    //         <Grid container spacing={2}>
    //             <Grid item>
    //                 <Box style={{ padding: '8px', width: '100px' }}>
    //                     <Image
    //                         src={imageUrl}
    //                         // onClick={() => console.log('onClick')}
    //                         style={{ cursor: 'pointer', borderRadius: 8 }}
    //                         onClick={handleOpen}
    //                         showLoading
    //                     />
    //                 </Box>
    //             </Grid>
                
    //             <Grid 
    //                 item 
    //                 direction='column'
    //             >
    //                 <Typography variant='subtitle2' display='block'>
    //                     {sku}
    //                 </Typography>
    //                 <Typography variant='caption' display='block'>
    //                     {name}
    //                 </Typography>
    //             </Grid>
    //         </Grid>

    //         <Modal open={open} onClose={handleClose}>
    //             <Box
    //                 sx={{
    //                     position: 'absolute',
    //                     top: '50%',
    //                     left: '50%',
    //                     transform: 'translate(-50%, -50%)',
    //                     outline: 'none',
    //                     boxShadow: 24,
    //                     bgcolor: 'background.paper',
    //                     borderRadius: 2,
    //                     maxWidth: '90%',
    //                     maxHeight: '90%',
    //                     p: 1,
    //                 }}
    //             >
    //             <Image
    //                 src={imageUrl}
    //                 fit='contain'
    //                 style={{ maxWidth: '100%', maxHeight: '80vh' }}
    //             />
    //             </Box>
    //         </Modal>
    //   </>
    // );
}

const createStockTableColumn = (cfg: any): any => {
    return {
        align: 'left',
        flex: true,
        width: 200,

        renderCell: renderer({
            ...cfg.cellRendererFactoryProps,
        }),

        valueFormatter: (props: any) => {
            return (props.value && props.value.name) ? props.value.name.bg : '';
        }
    }
}
export default createStockTableColumn;